// extracted by mini-css-extract-plugin
export default {"sectionHeading":"sectionHeading__3YlkK","icon":"icon__c-p+J","sectionContent":"sectionContent__8AjcL"};